/**
 * Утилита для скачивания файлов
 * @param {Blob} blob - Blob объект для скачивания
 * @param {string} filename - Имя файла для скачивания
 * @param {Object} options - Дополнительные опции
 * @param {boolean} options.openInNewTab - Открыть файл в новой вкладке
 * @param {Function} options.onComplete - Callback после скачивания
 */
export const downloadFile = (blob, filename, options = {}) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    if (options.openInNewTab) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
    }

    link.click();

    if (options.onComplete) {
        options.onComplete(url);
    } else {
        // Если нет callback, освобождаем память сразу
        URL.revokeObjectURL(url);
    }

    return url;
};

/**
 * Утилита для скачивания файла через API
 * @param {Function} apiCall - Функция API запроса, возвращающая blob
 * @param {string} filename - Имя файла для скачивания
 * @param {Object} options - Дополнительные опции
 */
export const downloadFileFromApi = async (apiCall, filename, options = {}) => {
    try {
        const { data } = await apiCall();
        return downloadFile(data, filename, options);
    } catch (error) {
        console.error('Ошибка при скачивании файла:', error);
        throw error;
    }
};

